import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import cardImageSrc from "images/demo/condominio-residencial.jpg";
import Header, { LogoLink, NavLink as NavLinkBase } from "../headers/HeaderLight";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg"

const NavLink = tw(NavLinkBase)`
  sm:text-sm sm:mx-6
`;
const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col lg:flex-row bg-blue-100 overflow-hidden lg:items-center`;
const LeftColumn = tw.div`ml-8 mr-8 xl:pl-10 py-8 lg:flex-1`;
const Content = tw.div`mt-8 lg:mt-0 flex flex-col sm:items-center lg:items-stretch`;
const Heading = tw.h1`text-3xl sm:text-5xl md:text-6xl lg:text-5xl font-black leading-none`;
const Paragraph = tw.p`max-w-md my-8 lg:my-5 lg:my-8 sm:text-lg lg:text-base xl:text-lg leading-loose`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-auto flex-shrink-0 relative`;
const Image = styled.img(props => [
    props.imageRounded && tw`rounded`,
    props.imageBorder && tw`border`,
    props.imageShadow && tw`shadow`,
]);

export default () => {

  const heading = (
    <>
      Mis Invitaciones.
      <wbr />
      <br />
      <span className="block text-primary-500 mt-8">Confirmadas y pendientes de activar.</span>
    </>
  );

  const description = "Aquí ves todas tus invitaciones activas. Las confirmadas ya tienen QR listo — compártelas solo con la persona registrada. Las pendientes esperan que el visitante active su pase.";

  return (
    <>
      <Header/>
      <Container>
        <TwoColumn>
          <LeftColumn>
            <Content>
              <Heading className="text-center">{heading}</Heading>
              <Paragraph>{description}</Paragraph>
            </Content>
          </LeftColumn>
          <ImageColumn>
            <Image css={null} src={cardImageSrc} imageBorder={false} imageShadow={false} imageRounded={true} />
          </ImageColumn>
        </TwoColumn>
      </Container>
    </>
  );
};
